import Waiting from "./waiting";
export default Waiting;